/* eslint-disable no-nested-ternary */
import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  reviews: [],
};

const slice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET reviews
    getReviews(state, action) {
      state.isLoading = false;
      state.reviews = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

export function getreviews(role, id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/${role}/provider/reviews?provider_id=${id}`);
      dispatch(slice.actions.getReviews(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
